import { Component, TemplateRef } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-alert',
  templateUrl: './auth-alert.component.html',
  styleUrls: ['./auth-alert.component.scss'],
})
export class AuthAlertComponent {


  constructor(config: NgbModalConfig, private modalService: NgbModal,private authService:AuthService) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;
  }

  openModal(template: TemplateRef<any>) {
    this.modalService.open(template, { size: 'md' ,centered: true,modalDialogClass: 'px-4'});
  }

  updateSession() {
    // let url = `${environment.msADRedirectAuthURL}`;
    // window.location.href = url;
    this.authService.getTokenByRefreshTokenSession();
    // this.authService.getTokenByRefreshToken2();
    

  }

}
